export default "__VITE_ASSET__6f4795d6__"